import { useContext, useEffect } from 'react';
import { DossierContext } from '../contexts/DossierContext.js';
import { SearchEntityStateActions, } from '../reducers/SearchEntityReducer/SearchEntityReducer.js';
import { useAdminEntities } from './useAdminEntities.js';
import { useAdminEntitiesSample } from './useAdminEntitiesSample.js';
import { useAdminEntitiesTotalCount } from './useAdminEntitiesTotalCount.js';
export function useAdminLoadEntitySearch(searchEntityState, dispatchSearchEntityState) {
    const { client } = useContext(DossierContext);
    // search
    const searchQuery = searchEntityState.paging
        ? searchEntityState.query
        : undefined;
    const { connection, connectionError } = useAdminEntities(client, searchQuery, searchEntityState.paging);
    const { totalCount } = useAdminEntitiesTotalCount(client, searchQuery);
    // sample
    const sampleQuery = !searchQuery ? searchEntityState.query : undefined;
    const { entitiesSample, entitiesSampleError } = useAdminEntitiesSample(client, sampleQuery, searchEntityState.sampling);
    useEffect(() => {
        dispatchSearchEntityState(new SearchEntityStateActions.UpdateSearchResult(connection, connectionError));
    }, [connection, connectionError, dispatchSearchEntityState]);
    useEffect(() => {
        dispatchSearchEntityState(new SearchEntityStateActions.UpdateTotalCount(totalCount ?? null));
    }, [totalCount, dispatchSearchEntityState]);
    useEffect(() => {
        dispatchSearchEntityState(new SearchEntityStateActions.UpdateSampleResult(entitiesSample, entitiesSampleError));
    }, [entitiesSample, entitiesSampleError, dispatchSearchEntityState]);
}
//# sourceMappingURL=useAdminLoadEntitySearch.js.map